export default __webpack_public_path__ + "static/media/facebook_m_logo.9eb481b5.svg";